'use client'
import { ComponentProps, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface Props extends ComponentProps<'div'> {
  header?: ReactNode
  children: ReactNode
  footer?: ReactNode
}

export default function MobileLayout({
  header,
  children,
  footer,
  className,
  ...props
}: Props) {
  return (
    <div
      className={twMerge('flex h-full w-full flex-col md:hidden', className)}
    >
      {header}
      <div className="w-full flex-[1] overflow-y-auto overflow-x-hidden">
        {children}
      </div>
      {footer}
    </div>
  )
}
